module.exports = __webpack_public_path__ + "img/green_096.f85324e5.png";